import { PureComponent } from "react";
import colors from "/styles/colors";

import ReadMoreComponent from "./read-more/read-more-component";
import { StyledBackgroundColorThumbnailItemComponent } from "./background-color-thumbnail-item-component.scss";

export default class BackgroundColorThumbnailItemComponent extends PureComponent {
  render() {
    const { title, link, color } = this.props;

    return (
      <StyledBackgroundColorThumbnailItemComponent href={link} className="background-color-thumbnail-item-component" style={{ backgroundColor: colors[color] }}>
        <div className="thumbnail-title">
          {title}
        </div>
        <ReadMoreComponent />
      </StyledBackgroundColorThumbnailItemComponent>
    );
  }
}
